import styled from 'styled-components';
import { Button } from 'core/components';

const AIAdvisorButton = styled(Button)`
  position: relative;
  padding: 0px 12px;
  border-radius: 0 8px;
  margin-right: 12px;
  background: linear-gradient(180deg, #14202a 0%, #223045 65.38%, #314666 100%);
  box-shadow: 2px 2px 0px #0e1e30;
  width: 70px;
  color: white;
  min-height: 32px;
  z-index: 1;
  overflow: hidden;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  &:hover {
    background: linear-gradient(180deg, #19252f 0%, #27354a 65.38%, #364b6b 100%);
    box-shadow:
      2px 3px 0px #0e1e30,
      0 4px 12px rgba(0, 0, 0, 0.2);
  }

  .bp4-icon {
    // forces white in dark mode.
    color: #fff !important;
    fill: #fff !important;
    transition: transform 0.2s ease;
  }

  &:hover .bp4-icon {
    transform: scale(1.1);
  }

  &::before {
    content: '';
    width: 70px;
    position: absolute;
    inset: 0;
    border-radius: inherit;
    padding: 1px;
    background: linear-gradient(90deg, #24c6dc 0%, #514a9d 25%, #b721ff 50%, #ff6b6b 75%, #24c6dc 100%);
    background-size: 300% 100%;
    mask:
      linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);
    mask-composite: xor;
    -webkit-mask-composite: destination-out;
    pointer-events: none;
    z-index: -1;
    transition: all 0.3s ease;
  }

  &:hover::before {
    animation: rainbow-border 6.75s linear infinite;
  }

  @keyframes rainbow-border {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 200% 100%;
    }
    100% {
      background-position: 0% 50%;
    }
  }
`;

export default AIAdvisorButton;
